module.exports = __webpack_public_path__ + "img/pic6.85c53ff5.png";